import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {environment} from '../../../../../environments/environment';
import {AdminUserModel} from '../../../../api/model/Admin-user.model';

@Component({
  selector: 'tj-admin-list',
  templateUrl: './admin-list.component.html',
  styleUrls: ['./admin-list.component.scss']
})
export class AdminListComponent {
  private readonly confirmationService = inject(ConfirmationService);
  @Input() admins: AdminUserModel[] = [];
  @Output() editAdmin = new EventEmitter<AdminUserModel>();
  @Output() deleteAdmin = new EventEmitter<AdminUserModel>();
  @Output('onSort') onSortEmitter = new EventEmitter();

  protected readonly env = environment;

  constructor() {
  }

  onSort($event: any) {
    this.onSortEmitter.emit($event);
  }

  onEdit(admin: AdminUserModel): void {
    this.editAdmin.emit(admin);
  }

  onDelete(admin: AdminUserModel): void {
    this.confirmationService.confirm({
      message: `Are you sure you want to delete admin "${admin.firstName} ${admin.lastName}"?`,
      header: 'Confirm Delete',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteAdmin.emit(admin);
      }
    });
  }
}
